import dayjs from "dayjs";

export function formatDateTime(input) {
  return dayjs(input).format("YYYY-MM-DD HH:mm:ss");
}

export function capitalizeFirstLetter(text) {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
}

let timeoutId;
export const debounce = (cb, delay = 500) => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(() => {
    cb();
  }, delay);
};

export const disableFuture = (current) => {
  const tomorrow = dayjs().add(1, "day").startOf("day");
  return current && current >= tomorrow;
};

export async function decryptToken(encrypted, keyHex, ivHex) {
  try {
    // Pad the token and safely decode
    const safeToken = padBase64(
      encrypted.replace(/-/g, "+").replace(/_/g, "/")
    );
    const encryptedData = Uint8Array.from(atob(safeToken), (c) =>
      c.charCodeAt(0)
    );

    const key = Uint8Array.from(
      keyHex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16))
    );
    const iv = Uint8Array.from(
      ivHex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16))
    );

    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      key,
      { name: "AES-CBC" },
      false,
      ["decrypt"]
    );
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-CBC", iv: iv },
      cryptoKey,
      encryptedData
    );
    return new TextDecoder().decode(decrypted);
  } catch (error) {
    console.error("Decryption error:", error);
  }
}

export function padBase64(base64) {
  return base64 + "=".repeat((4 - (base64.length % 4)) % 4);
}
